import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextAlignRightOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M3 5h26a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m26 6H10.58a1 1 0 1 0 0 2H29a1 1 0 0 0 0-2m0 8H3a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2m0 8H17.08a1 1 0 0 0 0 2H29a1 1 0 0 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconTextAlignRightOutlineSVG);
ForwardRef.displayName = "IconTextAlignRightOutline";
export { ForwardRef as IconTextAlignRightOutline };
